<mat-sidenav-container class="h-100">
  <mat-sidenav #sidenav>
    <ng-container #sidenavContent></ng-container>
  </mat-sidenav>

  <mat-sidenav-content class="position-relative">

    <soh-header></soh-header>

    <div class="d-flex">
      <soh-sidebar-menu></soh-sidebar-menu>

      <div class="flex-grow-1 soh-router-content p-3">
        <router-outlet></router-outlet>
      </div>
    </div>

  </mat-sidenav-content>

</mat-sidenav-container>

<bitf-mat-loader [diameter]="100"></bitf-mat-loader>